<template>
  <v-navigation-drawer    
    persistent
    id="LeftDrawer"
    :mini-variant="miniVariant"
    :clipped="clipped"
    v-model="drawer"
    enable-resize-watcher                
    :dark="$vuetify.dark"       
    width="260"
    fixed
    app
    >
    
    <v-toolbar :color="color+' darken-1'" dense dark>
      <img src="@/assets/logo.png" height="36" alt="Vue Material Admin Template">
      <v-toolbar-title class="ml-0 pl-3">
        <span>{{ title }}</span>
      </v-toolbar-title>        
    </v-toolbar>      
     
    <div id="left-scroll">      
      <v-img class="white--text" height="120px" :src="require('@/assets/img/bg/'+current_cover)">        
        <v-list-tile style="margin-top:55px" avatar @click="$router.push({path:'/profile'});">
          <v-list-tile-avatar :color="color">
            <img  v-if="avatar" :src="avatar" />
            <span v-else class="white--text headline">{{Muser.isLogin() ? user.attr.name.charAt(0):'x'}}</span>            
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title class="title" style="color:#fff">{{Muser.isLogin() ? user.attr.name : 'john doe'}}</v-list-tile-title>
            <small class="light-green--text" v-if="online"><v-icon color="green lighten-2">fa-circle</v-icon> online</small>
            <small class="red--text" v-else><v-icon color="red">fa-circle</v-icon> offline</small>              
            <offline @detected-condition="handleConnectivityChange">
              <!-- Only renders when the device is online -->              
            </offline>            
          </v-list-tile-content>
        </v-list-tile>
      </v-img>
      <v-list dense expand>
        <template v-for="(item, i) in menus">
            <!--group with subitems-->
            <v-list-group v-if="item.items && item.visible" :key="item.name" :group="item.group" :prepend-icon="item.icon" no-action="no-action">
              <v-list-tile slot="activator" ripple="ripple">
                <v-list-tile-content>
                  <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
              <template v-for="(subItem, i) in item.items">
                <!--sub group-->
                <v-list-group v-if="subItem.items" :key="subItem.name" :group="subItem.group" sub-group="sub-group">
                  <v-list-tile slot="activator" ripple="ripple">
                    <v-list-tile-content>
                      <v-list-tile-title>{{ subItem.title }}</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile v-for="(grand, i) in subItem.children" :key="i" :to="genChildTarget(item, grand)" :href="grand.href" ripple="ripple">
                    <v-list-tile-action v-if="grand.icon">
                        <v-icon>{{ grand.icon }}</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title>{{ grand.title }}</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list-group>
                <!--child item-->
                <v-list-tile v-else-if="subItem.visible" :key="i" :to="genChildTarget(item, subItem)" :href="subItem.href" :disabled="subItem.disabled" :target="subItem.target" ripple="ripple">
                  <v-list-tile-content>
                    <v-list-tile-title><span>{{ subItem.title }}</span></v-list-tile-title>
                  </v-list-tile-content>
                  <!-- <v-circle class="white--text pa-0 circle-pill" v-if="subItem.badge" color="red" disabled="disabled">{{ subItem.badge }}</v-circle> -->
                  <v-list-tile-action v-if="subItem.action">
                    <v-icon :class="[subItem.actionClass || 'success--text']">{{ subItem.action }}</v-icon>
                  </v-list-tile-action>
                </v-list-tile>
              </template>
            </v-list-group>
            <v-subheader v-else-if="item.header && item.visible" :key="i">{{ item.header }}</v-subheader>
            <v-divider v-else-if="item.divider && item.visible" :key="i"></v-divider>
            <!--top-level link-->
            <v-list-tile v-else-if="item.visible" :to="!item.href ? { name: item.name } : null" :href="item.href" ripple="ripple" :disabled="item.disabled" :target="item.target" rel="noopener" :key="item.name">
              <v-list-tile-action v-if="item.icon">
                <v-icon>{{item.icon }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>{{ item.title }}</v-list-tile-title>
              </v-list-tile-content>
              <!-- <v-circle class="white--text pa-0 chip--x-small" v-if="item.badge" :color="item.color || 'primary'" disabled="disabled">{{ item.badge }}</v-circle> -->
              <v-list-tile-action v-if="item.subAction">
                <v-icon class="success--text">{{ item.subAction }}</v-icon>
              </v-list-tile-action>
              <!-- <v-circle class="caption blue lighten-2 white--text mx-0" v-else-if="item.chip" label="label" small="small">{{ item.chip }}</v-circle> -->
            </v-list-tile>
        </template>                
      </v-list>            
    </div>        
  </v-navigation-drawer>
</template>
<script>
import config  from '@/config'  
import Muser   from '@/util/models/User';
import offline from 'v-offline';

let menu = require('@/apps/'+config.apps+'/router/navmenu');

export default {
  name: 'app-left-drawer',
  components: {
    offline
  },
  props: {
    expanded: {
      type: Boolean,
      default: true
    },
  },
  data: () => ({
    dialog: false,
    online : window.navigator.onLine,  
    title : config.title,
    color: config.color,
    username : null,
    miniVariant:false,
    clipped :false,
    mini: false,
    drawer: true,    
    orgns: [],
    scrollSettings: {
      maxScrollbarLength: 60
    },
    formModel :{
       user_id : null,       
    },
    Muser:Muser,
    user:Muser.info(),
    avatar:Muser.info() && Muser.info().avatar? Muser.info().avatar:null,
    orgn_id : null,
    current_cover : '1.jpg',       
  }),  
  computed: {
    computeGroupActive () {
      return true;
    },    
    sideToolbarColor () {
      return this.$vuetify.options.extra.sideNav;
    },
    menus(){      
      return menu.default();
    }
  },
  created () {       
    this.getCover();
    window.getApp.$on('APP_LEFT_DRAWER_TOGGLED', () => {
      this.drawer = (!this.drawer);
    });
    window.getApp.$on('APP_LEFT_MINI_VARIANT', () => {
      this.miniVariant = (!this.miniVariant);
    });
    window.getApp.$on('APP_LEFT_CLIPPED', () => {
      this.clipped = (!this.clipped);
    });       
  },
  

  methods: {
    genChildTarget (item, subItem) {
      if (subItem.href) return;
      if (subItem.component) {
        return {
          name: subItem.component,
        };
      }
      if(!item.group){
        if(subItem.name){
          return { name: `${subItem.name}` };
        } else if(subItem.path){
          return { path: `${subItem.path}` };
        }
      }
      if(!subItem.name)
        return { name: `${item.group}` };
      return { name: `${item.group}/${(subItem.name)}` };
    },
    scrollHanle(/*evt*/) {
      
    },
    getCover(){
      var _  = require('lodash');
      var randomArray   = ['1.jpg','11.jpg', '12.jpg','13.jpg','14.jpg','16.jpg'];
      var randomElement = _.sample(randomArray);
      this.current_cover = randomElement;       
    },
    handleConnectivityChange(status) {
      this.online = status;
    },    
  }
};
</script>
<style lang="stylus">
  #left-scroll{
      height: calc(100vh - 64px);
      overflow: auto;
  }  
</style>
